import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faPrint } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import LoadingApp from "../../../../components/LoadingApp";
import ModalFeedBack from "../../../../components/ModalFeedBack";
import { ComponenteCadastralData } from "../../../../interfaces/entities/ComponenteCadastral/ComponenteCadastralData";
import { getMeuPlanoSaude } from "../../../../services/BeneficiarioService";
import "../styles.css";
import {
  sxButtonText,
  sxButtonTextPrint,
  sxTab,
  sxTabs,
  sxTabsAccessibility,
} from "../sxProps";
import ComponenteCadastralBeneficiarioData from "./ComponenteCadastralBeneficiarioData";
import ComponenteCadastralOperadoraData from "./ComponenteCadastralOperadoraData";
import ComponenteCadastralPlanoData from "./ComponenteCadastralPlanoData";
import { getGerarRelatSaudeSuplementar } from "../../../../services/RelatorioService";
import { base64toBlob } from "../../../../utils/Base64ToBlob";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import PageTitle from "../../../../components/Accessibility/PageTitle";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const ComponenteCadastral = () => {
  const navigate = useNavigate();

  const accessibility = useAccessibility();

  const [loading, setLoading] = useState<boolean>(false);
  const [componenteCadastralData, setComponenteCadastralData] =
    useState<ComponenteCadastralData>();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: "error" | "success" | "warning";
    title?: string;
    textButton?: string;
    subTitle?: string;
    closeAction: () => void;
    showButtonModal: boolean;
    buttonAction?: () => void;
  }>(null);

  useEffect(() => {
    getPlano();
  }, []);

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const getPlano = async () => {
    setLoading(true);

    var response = await getMeuPlanoSaude();

    if (response?.status !== 200) {
      setModalFeedback({
        icon: "error",
        title: "Ocorreu um erro",
        subTitle: response?.data.mensagem
          ? response?.data.mensagem
          : "Erro ao consultar informações.",
        textButton: "Fechar",
        closeAction: () => setModalFeedback(null),
        buttonAction: () => setModalFeedback(null),
        showButtonModal: false,
      });
      setLoading(false);
      return;
    } else {
      setComponenteCadastralData(response.data);
      setLoading(false);
      return;
    }
  };

  const printIdent = () => {
    setLoading(true);
    getGerarRelatSaudeSuplementar()
      .then((response) => {
        if (response?.data) {
          const pdf = response.data.dados.conteudo;
          const blob = base64toBlob(pdf);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        }
      })
      .catch((response) => {
        setModalFeedback({
          icon: "error",
          title: "Ocorreu um erro",
          subTitle: response?.data?.mensagem
            ? response?.data.mensagem
            : "Erro ao consultar informações.",
          textButton: "Fechar",
          closeAction: () => setModalFeedback(null),
          buttonAction: () => setModalFeedback(null),
          showButtonModal: false,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="container-info-plan ">    
      <PageTitle text="Informações do plano (PIN-SS)" />
      <div className="width-100">
        <Tabs
          value={value}
          onChange={handleChange}
          sx={accessibility.contrastMode ? sxTabsAccessibility : sxTabs}
          textColor="inherit"
        >
          <Tab
            tabIndex={0}
            style={accessibility.textStyleAccessibility}
            label="Beneficiário(a)"
            {...a11yProps(0)}
            sx={sxTab}
            disableRipple
            disableTouchRipple
            disableFocusRipple
          />
          <Tab
            tabIndex={0}
            style={accessibility.textStyleAccessibility}
            label="Plano"
            {...a11yProps(1)}
            sx={sxTab}
            disableRipple
            disableTouchRipple
            disableFocusRipple
          />
          <Tab
            tabIndex={0}
            style={accessibility.textStyleAccessibility}
            label="Operadora"
            {...a11yProps(2)}
            sx={sxTab}
            disableRipple
            disableTouchRipple
            disableFocusRipple
          />
        </Tabs>
        <CustomTabPanel value={value} index={0}>
          {componenteCadastralData && (
            <ComponenteCadastralBeneficiarioData
              identificacaoBeneficiario={
                componenteCadastralData?.identificacaoBeneficiario
              }
            />
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {componenteCadastralData && (
            <ComponenteCadastralPlanoData
              identificacaoPlano={componenteCadastralData?.identificacaoPlano}
            />
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          {componenteCadastralData && (
            <ComponenteCadastralOperadoraData
              identificacaoOperadora={
                componenteCadastralData?.identificacaoOperadora
              }
            />
          )}
        </CustomTabPanel>
      </div>
      <div>
        <Button
          onClick={() => {
            printIdent();
          }}
          variant="text"
          startIcon={
            <FontAwesomeIcon
              style={accessibility.textStyleAccessibility}
              icon={faPrint}
            />
          }
        >
          <Typography
            style={{ ...accessibility.textStyleAccessibility }}
            sx={sxButtonTextPrint}
          >
            Imprimir identificação completa
          </Typography>
        </Button>
      </div>
      <div className="container-button-back-servicos">
        <Button
          onClick={() => navigate(-1)}
          startIcon={
            <FontAwesomeIcon
              style={accessibility.textStyleAccessibility}
              icon={faChevronLeft}
              color="#383838"
            />
          }
        >
          <Typography
            style={{ ...accessibility.textStyleAccessibility }}
            sx={sxButtonText}
          >
            Voltar
          </Typography>
        </Button>
      </div>
      <LoadingApp showLoading={loading} />
      <ModalFeedBack
        showModal={!!modalFeedback}
        icon={modalFeedback?.icon as "success" | "error"}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        showButtonModal={modalFeedback?.showButtonModal}
        handleShowModal={modalFeedback?.closeAction}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </div>
  );
};

export default ComponenteCadastral;
